import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

export const StoreOpenRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;

  & .approval-form-table.is-editable td.is-readonly {
    padding: 6px;
  }
`;

/** 제목 줄 오른쪽에 단위 */
export const SectionHeader = styled(Box)`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;

  & > p {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const StoreOpenDetailRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    minWidth: 720,
  },
  // 칸이 적은 매장명·요약 표는 좁은 화면에서도 화면 너비에 맞춤
  '& table.store-open-fit': { minWidth: 0 },
  '& td': { textAlign: 'center' },
  '& .align-right, & .text-right': { textAlign: 'right' },
  '& .text-center': { textAlign: 'center' },
  '& tr.store-open-subtotal td': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 600,
  },
}));

export const StoreOpenDetailMessage = styled('p')({
  margin: 0,
  padding: '24px 0',
  textAlign: 'center',
  fontSize: 14,
  color: 'var(--dk-text-strong, #4D5157)',
});

export const StoreOpenSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
